module.exports = "./img/cbb5e7430992c680ec739e2236655a7d.png";